"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _styles = require("@material-ui/core/styles");

var _ArticleGrid = _interopRequireDefault(require("./ArticleGrid"));

var _ArticleTitle = _interopRequireDefault(require("./ArticleTitle"));

var _ArticleBodytext = _interopRequireDefault(require("./ArticleBodytext"));

var _ArticleMedia = _interopRequireDefault(require("./ArticleMedia"));

var _ArticleReferences = _interopRequireDefault(require("./ArticleReferences"));

var _ArticleLinks = _interopRequireDefault(require("./ArticleLinks"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const useStyles = (0, _styles.makeStyles)(theme => ({
  head: {}
}));

const ArticleHead = ({
  className,
  language,
  title,
  leadtext,
  media
}) => {
  const classes = useStyles();
  return _react.default.createElement("header", {
    className: className || classes.head
  }, _react.default.createElement(_ArticleGrid.default, null, _react.default.createElement(_ArticleTitle.default, {
    language: language
  }, title), media && _react.default.createElement(_ArticleMedia.default, {
    media: media,
    layout: "list",
    mediaFormat: "2:1"
  }), _react.default.createElement(_ArticleBodytext.default, {
    language: language
  }, leadtext)));
};

var _default = ArticleHead;
exports.default = _default;
module.exports = exports.default;